import { QueryOptions } from '../../components/Common/useQuery';
import useUserOrEmployeeQuery from '../../components/Common/useUserOrEmployeeQuery';
import { useUserOrKaEmployee } from '../../components/UserAccess/useUserOrKaEmployee';
import { PaginatedResult, PaginationParams } from '../usePaginatedQuery';

export interface FieldAlyticsApiRequest {
  id: string;
  direction: string;
  timestamp: string;
  method: string;
  path: string;
  body: string | null;
  responseStatusCode: number | null;
  responseBody: string | null;
}

const useGetFieldAlyticsApiRequests = (
  params: PaginationParams,
  options?: QueryOptions<PaginatedResult<FieldAlyticsApiRequest>>
) => {
  const { selectedBusiness } = useUserOrKaEmployee();
  const urlParams = new URLSearchParams({
    page: params.page.toString(),
    pageSize: params.pageSize.toString()
  });
  return useUserOrEmployeeQuery<PaginatedResult<FieldAlyticsApiRequest>>(
    { path: `/api/integrations/fieldalytics/${selectedBusiness?.id}/apiRequests?${urlParams.toString()}` },
    { ...options, rewriteToEmployeeApi: false }
  );
};

export default useGetFieldAlyticsApiRequests;
